import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class CommentItem {

    private _commentItemId: string;
    private _name: string;
    private _createdDate: Date;
    private _changedDate: Date;
    private _comment: string;
    private _folderId: string | null;

    public constructor(commentItemId: string, name: string, createdDate: Date, changedDate: Date, comment: string, folderId: string | null) {

        this._commentItemId = commentItemId;
        this._name = name;
        this._createdDate = createdDate;
        this._changedDate = changedDate;
        this._comment = comment;
        this._folderId = folderId;
    }

    public get commentItemId(): string {
        return this._commentItemId;
    }

    public set commentItemId(value: string) {
        this._commentItemId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get createdDate(): Date {
        return this._createdDate;
    }

    public set createdDate(value: Date) {
        this._createdDate = value;
    }

    public get changedDate(): Date {
        return this._changedDate;
    }

    public set changedDate(value: Date) {
        this._changedDate = value;
    }

    public get comment(): string {
        return this._comment;
    }

    public set comment(value: string) {
        this._comment = value;
    }

    public get folderId(): string | null {
        return this._folderId;
    }

    public set folderId(value: string | null) {
        this._folderId = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): CommentItem | null {

        const commentItemId: string | null = safeParseNullDefault<string>(object?._commentItemId, '');
        const name: string = safeParse<string>(object?._name, '');
        const createdDate: Date | null = safeParseNullDefault<Date>(object?._createdDate, new Date());
        const changedDate: Date | null = safeParseNullDefault<Date>(object?._changedDate, new Date());
        const comment: string = safeParse<string>(object?._comment, '');
        const folderId: string | null = safeParseNullDefault<string>(object?._folderId, '');

        if (commentItemId === null || createdDate === null || changedDate === null || commentItemId === '') {
            return null;
        }

        return new CommentItem(commentItemId, name, createdDate, changedDate, comment, folderId);
    }
}

export default CommentItem;